import { render } from "./NetworkStatus.vue?vue&type=template&id=5cfa00f5&scoped=true"
import script from "./NetworkStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./NetworkStatus.vue?vue&type=script&setup=true&lang=js"

import "./NetworkStatus.vue?vue&type=style&index=0&id=5cfa00f5&scoped=true&lang=css"

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfa00f5"],['__file',"src/components/UI/NetworkStatus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cfa00f5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cfa00f5', __exports__)) {
    api.reload('5cfa00f5', __exports__)
  }
  
  module.hot.accept("./NetworkStatus.vue?vue&type=template&id=5cfa00f5&scoped=true", () => {
    api.rerender('5cfa00f5', render)
  })

}


export default __exports__